<template>
  <section :class="$style.open_hour">
    <div :id="$style.opening_hours">
      <div :id="$style.sub_title">
        <h2>4. ニューヨークとベースボールとジーターと松井 <br><h3>(15分)</h3></h2>
      </div>
    </div>
    <div :class="$style.middle_title">
      〜 静かなる男たちの友情 〜
    </div>
    ヤンキース時代のチームメイト・親友ジーターさんとの友情や絆を描いています。
        来館時の映像などジーターさんとのエピソードが満載です。
  </section>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "OpenHourVisual",
  components: {

  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  .open_hour {
    text-align: center;

    #opening_hours {
      margin-bottom: 20px;
      #time {
        background-color: rgba(63, 107, 120, 1);
        color: #fff;
        height: 35px;
        font-size: 19px;
        display: flex;
        align-items: center;
        padding-left: 20px;
      }
      h3 {
        font-size: 20px;
      }
    }
    .middle_title {
      font-size: 18px;
      color: #46ca0e;
      margin-bottom: 8px;
      text-align: center;
    }
  }
}
@media only screen and (min-width: 1024px) {
  .open_hour {
    text-align: center;

    #opening_hours {
      margin-bottom: 20px;
      #time {
        background-color: rgba(63, 107, 120, 1);
        color: #fff;
        height: 35px;
        font-size: 19px;
        display: flex;
        align-items: center;
        padding-left: 20px;
      }

      #sub_title {
        color: #3b342a;
        h3 {
            font-size: 23px;
        }
      }
    }
    .middle_title {
      font-size: 18px;
      color: #46ca0e;
      margin-bottom: 8px;
      text-align: center;
    }
  }
}
</style>
